import { render, staticRenderFns } from "./pre_textareaedit.vue?vue&type=template&id=16222967&scoped=true"
import script from "./pre_textareaedit.vue?vue&type=script&lang=js"
export * from "./pre_textareaedit.vue?vue&type=script&lang=js"
import style0 from "./pre_textareaedit.vue?vue&type=style&index=0&id=16222967&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16222967",
  null
  
)

export default component.exports